// DocumentSearchError — backend failure state (CTSK-493 §3 item 7;
// design doc §3.7): “Search temporarily unavailable. [Retry]”. Retry
// re-fires the last query through the hook's `refetch`; nothing here
// retries on its own (no retry storms).

export interface DocumentSearchErrorProps {
  onRetry: () => void;
}

export function DocumentSearchError({ onRetry }: DocumentSearchErrorProps) {
  return (
    <div className="doc-search__state" role="alert" data-testid="document-search-error">
      <p>Search temporarily unavailable.</p>
      <button
        type="button"
        className="btn btn--ghost"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
}
